import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ReorderablePrimerGrid } from "../../components/grids/ReorderablePrimerGrid";

const queryClient = new QueryClient();

export class ReorderablePrimerGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <ReorderablePrimerGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
}
